<template>
  <v-btn depressed :color="'#' + vehicle.color">{{ vehicle.title }}</v-btn>
</template>

<script>
export default {
  name: 'Vehicle',
  props: ['vehicleID'],
  computed: {
    vehicle () {
      const vehicle = this.$store.state.vehicle.all.find(vehicle => vehicle.id === this.vehicleID)
      if (vehicle === undefined) {
        return {
          title: '',
          color: ''
        }
      }
      return vehicle
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/_vehicle.vue